// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__uop-R","copyright":"Footer_copyright__WE24Y"};